import type { ToolDescriptor } from "../manifest/schema";
import type { WireTool } from "../wire/protocol";

/**
 * What a frame puts on the wire to say *I can answer this*.
 *
 * ⚠️ **Declaring is now load-bearing, not decorative.** `resolveImplementor`
 * dispatches a frame-answered tool only to a frame that declares it, so a tool
 * implemented but not declared is unreachable, and one declared but not
 * implemented is an `unknown_tool` at the far end. Both sets come from the same
 * array here for exactly that reason.
 */
export function declare(descriptors: readonly ToolDescriptor[]): WireTool[] {
  return descriptors.map((descriptor) => ({
    name: descriptor.name,
    description: descriptor.description,
    inputSchema: descriptor.inputSchema as unknown as WireTool["inputSchema"],
    destructiveHint: descriptor.destructiveHint === true,
    canAwaitUser: descriptor.canAwaitUser,
    settlesBeforeResolving: descriptor.settlesBeforeResolving,
  }));
}
